var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SPreloader'),_c('SLandingTopBar'),_c('div',{staticClass:"header-spacer--standard"}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"login-content"},[_c('SLoginCard')],1)]),_c('FooterUnlogged'),(!_vm.storageCookies)?_c('CookiesAndPrivacy',{on:{"cookies-privacy":_vm.accept}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }